import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Calendar, CalendarPlatform } from 'src/meetings/models';

type CreateCalendarInput = {
  authCode: string;
  state: string;
  platform: CalendarPlatform;
};

export const useCreateCalendarMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: Calendar }, Error, CreateCalendarInput>({
    mutationFn: (input: CreateCalendarInput) => api.post<Calendar>('calendars', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendars'] });
    },
  });

  const createCalendar = async (input: CreateCalendarInput): Promise<Calendar> => {
    const response = await mutateAsync(input);
    return response.data;
  };

  return {
    createCalendar,
    isLoading,
    error,
  };
};
